import type { IEntityInfo, ServiceOffering, TermAndCondition } from '@core/models/app.model';
import type { IUserBasicInfo } from '@core/models/user.model';

export interface IServiceOfferingConfiguration {
  guid: string;
  name: string;
  status: ServiceLogicalStatus;
  lastUpdated: Date | string;
  lastActivated: Date | string;
  activationType: ServiceActivationType;
  visibleTo: string[];
  index: number;
  image: string;
  isHidden: boolean;
}

export interface IServiceOfferingMetadata {
  name: string;
  image: string;
  activationType: ServiceActivationType;
  paidService: boolean;
  description: string;
  benefits: string;
  isDraft: boolean;
  serviceFee: number;
  visibleTo: string[];
  canEdit: boolean;
  isHidden: boolean;
}

export interface ICompanyServiceOffering {
  guid: string;
  name: string;
  image: string;
  description: string;
  benefits: string;
  status: ServiceLogicalStatus;
  paidService: boolean;
  offeringCode: ServiceOffering;
  timestamp: Date | string | null;
}

export interface ITACInfo {
  linkedTermsAndConditions: TermAndCondition[];
  notLinkedTermsAndConditions: TermAndCondition[];
}

export interface IUploadTermData {
  serviceOfferingId: string;
  termsAndConditions: TermAndCondition;
}

export interface ITermHistory {
  user: IUserBasicInfo;
  action: TermsAndConditionsAction;
  timestamp: string | Date;
}

export interface ITACHistory {
  name: string;
  signDate: string;
  publishedDate: string;
}

export interface IServiceSubscription {
  guid: string;
  company: IEntityInfo;
  service: string;
  requestDate: string;
  activationDate: string;
  status: ServiceLogicalStatus;
}

export const SERVICE_LOGICAL_STATUS = {
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  UPDATING: 'UPDATING',
  DEPRECATED: 'DEPRECATED',
  DELETED: 'DELETED',
  REQUESTED: 'REQUESTED',
} as const;

export type ServiceLogicalStatus =
  (typeof SERVICE_LOGICAL_STATUS)[keyof typeof SERVICE_LOGICAL_STATUS];

export const SERVICE_ACTIVATION_TYPE = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
} as const;

export type ServiceActivationType =
  (typeof SERVICE_ACTIVATION_TYPE)[keyof typeof SERVICE_ACTIVATION_TYPE];

export const TERMS_AND_CONDITIONS_ACTION = {
  CREATE_TERMS_AND_CONDITIONS: 'Create',
  DELETE_TERMS_AND_CONDITIONS: 'Delete',
  UPDATE_TERMS_AND_CONDITIONS: 'Update',
  LINK_TERMS_AND_CONDITIONS: 'Link',
  UNLINK_TERMS_AND_CONDITIONS: 'Unlink',
} as const;

export type TermsAndConditionsAction =
  (typeof TERMS_AND_CONDITIONS_ACTION)[keyof typeof TERMS_AND_CONDITIONS_ACTION];
